<template>
  <div class="reports-one">
    <div class="row">
      <div class="col-sm-6">
        <page-title
          v-if="isLoading === true"
          title="Medewerkers weekoverzicht"
          icon="activities"
        ></page-title>
        <page-title
          v-else
          :title="'Medewerkers week ' + $moment(dateStart).format('W')"
          icon="activities"
        ></page-title>
      </div>
      <div class="col-sm-6 text-end" style="padding-top: 12px">
        <date-range-select
          type="week"
          @changeDateRange="getReportData($event.dateStart, $event.dateEnd)"
        ></date-range-select>
      </div>
    </div>
    <div v-if="isLoading === true">
      <p class="text-center" style="margin: 50px">
        Laden...
      </p>
    </div>
    <div v-else-if="reportData">
      <!-- groups -->
        <span v-bind:key="group.id" v-for="group in reportData.groups">
         <span v-if="group.employees.length > 0">
          <div class="table-responsive">
            <table class="table table-striped">
              <thead>
                <tr class="table-dark">
                  <td class="text-white" width="200"><b>{{ group.group.name }}</b></td>
                  <td class="text-white" v-bind:key="dateKey" v-for="(date, dateKey) in reportData.dates">
                      <b>{{ this.$moment(date).format('ddd D MMM')}}</b>
                  </td>
                </tr>
              </thead>
              <tbody>

                <tr>
                  <td width="200"></td>
                  <td v-bind:key="key" v-for="(occupationForOneDate, key) in group.occupation">
                    <!--<b>{{ date.morning }} / {{ date.afternoon }}</b>-->
                    <child-ratio-bar v-if="occupationForOneDate.ratio.length > 0" :date="key" :data="occupationForOneDate" style="padding-left: 10px; padding-right: 10px;" />
                    <p v-else class="text-center" style="line-height: 44px; margin-bottom: 0">
                      <b>-</b>
                    </p>
                  </td>
                </tr>
                <tr v-bind:key="employee.id" v-for="employee in group.employees">
                  <td width="200">{{ employee.name }}</td>
                  <td v-bind:key="key" v-for="(timeBlocks, key) in employee.dates">
                    <span v-bind:key="index" v-for="(timeBlock, index) in timeBlocks">
                      {{ timeBlock.activity.listName || '?' }}
                      <br>
                      {{ timeBlock.startTime.substr(0, 5) }} - {{ timeBlock.endTime.substr(0, 5) }}
                      <br>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <br>
        </span>
      </span>
      <!-- available employees -->
      <span v-if="reportData.available_employees">
        <div class="table-responsive">
          <table class="table table-striped">
            <thead>
              <tr class="table-dark">
                <td class="text-white"><b>Beschikbaar</b></td>
                <td class="text-white" v-bind:key="index" v-for="(date, index) in reportData.dates">
                    <b>{{ this.$moment(date).format('ddd D MMM')}}</b>
                </td>
              </tr>
            </thead>
            <tbody>
              <tr v-bind:key="employee.id" v-for="employee in reportData.available_employees">
                <td>{{ employee.name }}</td>
                <td v-bind:key="index" v-for="(timeBlocks, index) in employee.dates">
                  <span v-bind:key="key" v-for="(timeBlock, key) in timeBlocks">
                    {{ timeBlock.starttime.substr(0, 5) }} - {{ timeBlock.endtime.substr(0, 5) }}
                    <br>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <br>
      </span>
    </div>
  </div>
</template>

<script>
import PageTitle from '@/components/Page-Title'
import DateRangeSelect from '@/components/Date-Range-Select'
import ChildRatioBar from '@/components/Child-Ratio-Bar'
export default {
  name: 'reports-one',
  components: {
    PageTitle,
    DateRangeSelect,
    ChildRatioBar
  },
  computed: {
    selectedEstablishment () {
      return this.$store.getters.selectedEstablishment
    }
  },
  data () {
    return {
      isLoading: false,
      dateStart: null,
      dateEnd: null,
      reportData: []
    }
  },
  methods: {
    getReportData (dateStart, dateEnd) {
      this.isLoading = true
      this.$request.post(process.env.VUE_APP_API_V3_URL + '/reports/employee-week-overview', {
        ...this.$request.getDeprecatedBodyAuthentication(),
        data: {
          id_establishment: this.selectedEstablishment.id,
          date_start: dateStart,
          date_end: dateEnd
        }
      }).then((data) => {
        this.isLoading = false
        this.reportData = data
        this.dateStart = dateStart
        this.dateEnd = dateEnd
      })
    }
  }
}
</script>

<style>
</style>
